import React from "react";
import { PiBalloonThin } from "react-icons/pi";

const BalloonDrop = () => {
  return (
    <div className="fixed -top-[500px]">
      <PiBalloonThin className="relative left-[100px] text-7xl bg-red-500 rounded-full animate-fall opacity-0 delay-9000">
        <div className="absolute top-full -translate-x-1/2 w-0.5 h-6 bg-gray-400"></div>
      </PiBalloonThin>
      <PiBalloonThin className="relative left-[300px] text-7xl bg-green-500 rounded-full animate-fall opacity-0 delay-5000 ">
        <div className="absolute top-full -translate-x-1/2 w-0.5 h-6 bg-gray-400"></div>
      </PiBalloonThin>
      <PiBalloonThin className="relative left-[450px] text-7xl bg-blue-500 rounded-full animate-fall opacity-0 delay-3000 ">
        <div className="absolute top-full -translate-x-1/2 w-0.5 h-6 bg-gray-400"></div>
      </PiBalloonThin>
      <PiBalloonThin className="relative left-[550px] text-7xl bg-yellow-500 rounded-full animate-fall opacity-0 delay-7000 ">
        <div className="absolute top-full -translate-x-1/2 w-0.5 h-6 bg-gray-400"></div>
      </PiBalloonThin>
      <PiBalloonThin className="relative left-[600px] text-7xl bg-red-500 rounded-full animate-fall opacity-0 delay-5000">
        <div className="absolute top-full -translate-x-1/2 w-0.5 h-6 bg-gray-400"></div>
      </PiBalloonThin>
      <PiBalloonThin className="relative left-[1200px] text-7xl bg-green-500 rounded-full animate-fall opacity-0 delay-2000 ">
        <div className="absolute top-full -translate-x-1/2 w-0.5 h-6 bg-gray-400"></div>
      </PiBalloonThin>
      <PiBalloonThin className="relative left-[500px] text-7xl bg-blue-500 rounded-full animate-fall opacity-0 delay-6000 ">
        <div className="absolute top-full -translate-x-1/2 w-0.5 h-6 bg-gray-400"></div>
      </PiBalloonThin>
      <PiBalloonThin className="relative left-[800px] text-7xl bg-yellow-500 rounded-full animate-fall opacity-0 delay-4000 ">
        <div className="absolute top-full -translate-x-1/2 w-0.5 h-6 bg-gray-400"></div>
      </PiBalloonThin>
    </div>
  );
};

export default BalloonDrop;
